import React from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

interface CreateCustomGroupDialogProps {
  open: boolean;
  newGroupName: string;
  createError: string | null;
  isLoading: boolean;
  isValidating: boolean;
  groupNameExists: boolean;
  onClose: () => void;
  onGroupNameChange: (name: string) => void;
  onCreateGroup: () => Promise<void>;
}

const CreateCustomGroupDialog: React.FC<CreateCustomGroupDialogProps> = ({
  open,
  newGroupName,
  createError,
  isLoading,
  isValidating,
  groupNameExists,
  onClose,
  onGroupNameChange,
  onCreateGroup,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Create New Custom Group</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Group Name"
          fullWidth
          variant="outlined"
          value={newGroupName}
          onChange={(e) => onGroupNameChange(e.target.value)}
          error={!!createError || groupNameExists}
          helperText={
            createError || 
            (isValidating ? 'Validating...' : groupNameExists ? 'A group with this name already exists' : '')
          }
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onCreateGroup}
          variant="contained"
          disabled={isLoading || isValidating || !newGroupName.trim() || groupNameExists}
        >
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCustomGroupDialog;